export type DocumentExportedPayload = {
	readonly documentId: number;
};

/** Success action with no server-supplied document: an export is a local side effect (browser
 * download from content already fetched), never a mutation the store needs to reconcile. It still
 * has to exist and be dispatched/returned — an applicative function is never allowed to return
 * `Promise<void>`. */
export type DocumentExportedAction = {
	type: 'DOCUMENT_EXPORTED';
	payload: DocumentExportedPayload;
};

export default (payload: DocumentExportedPayload): DocumentExportedAction => ({
	type: 'DOCUMENT_EXPORTED',
	payload,
});
